import React, { FC, memo, useCallback } from 'react';
import { Grid } from '@material-ui/core';

import useStyles from './styles';

interface FieldLabelProps {
  label: string | JSX.Element;
  isRequired?: boolean;
  description?: JSX.Element | string;
  icon?: JSX.Element | string;
  style?: any;
  classLabel?: string;
  classRequired?: string;
  children?: React.ReactNode;
}

export const FieldLabel: FC<FieldLabelProps> = memo(({ label, isRequired, icon, description = undefined, style, classLabel, classRequired, children }) => {
  const classes = useStyles();

  const getLabel = useCallback(
    () => (
      <p className={`${classes.formLabel} ${classLabel}`} style={style}>
        {label}
        {isRequired ? <span className={`${classes.formRequired} ${classRequired}`}>*</span> : <></>}
        <span className={classes.icon}>{icon}</span>
        {children}
      </p>
    ),
    [classes, isRequired, label, icon, style, classLabel, classRequired, children],
  );

  return description ? (
    <Grid container justify="space-between">
      <Grid item>{getLabel()}</Grid>
      <Grid item>{description}</Grid>
    </Grid>
  ) : (
    <>{getLabel()}</>
  );
});
